import Link from "../../../components/Link";
import Number from "../../../components/Number";
import { IDialogField, IListviewField } from "../../../services/types";
import { formatBoolean, getCurrentUrlAsSource } from "../../../services/utils";
import { CurrentNavigationItemFull } from "./types";
import { dispForm } from "./urls";

export const name: IListviewField<CurrentNavigationItemFull> & IDialogField<CurrentNavigationItemFull> = {
  title: "Name",
  fieldName: "name",
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => (
    <Link href={`${dispForm}/${item.id}?${getCurrentUrlAsSource()}`}>{item.name}</Link>
  ),
  renderDialogValue: (item: CurrentNavigationItemFull) => item.name,
};

export const url: IListviewField<CurrentNavigationItemFull> & IDialogField<CurrentNavigationItemFull> = {
  title: "Url",
  fieldName: "url",
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => <>{item.url && <Link href={item.url} />}</>,
  renderDialogValue: (item: CurrentNavigationItemFull) => item.url,
};

export const order: IListviewField<CurrentNavigationItemFull> = {
  title: "Reihenfolge",
  fieldName: "order",
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => <Number value={item.order} />,
};

export const openNewTab: IListviewField<CurrentNavigationItemFull> = {
  title: "Neuem Tab",
  fieldName: "openNewTab",
  isFilterable: true,
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => formatBoolean(item.openNewTab),
};

export const parent: IListviewField<CurrentNavigationItemFull> & IDialogField<CurrentNavigationItemFull> = {
  title: "Übergeordnetes",
  fieldName: "parent.name",
  isFilterable: true,
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => item.parent?.name,
  renderDialogValue: (item: CurrentNavigationItemFull) => item.parent?.name,
};

export const schema: IListviewField<CurrentNavigationItemFull> = {
  title: "Schema",
  fieldName: "schema.name",
  isFilterable: true,
  isSortable: true,
  renderListValue: (item: CurrentNavigationItemFull) => item.schema?.name,
};
